import { localizedStrings } from 'lib/l10n/l10n';
import { PRODUCT_LECTURA, PRODUCT_READING } from 'root/lib/constants';
import mapLocations from '../../data/MapLocations';
import { SEASON } from '../../data/constants';
import gameIds from '../../data/GameIds';
import STEP_TYPE from '../../data/StepTypes';
import MapQuests from '../../data/MapQuests.json';

/*
     List of fields we expect for eReader in quest step
*/
/*
  type: STEP_TYPE.EREADER,
  game: 'ereader.gym_class',
  friendlyName: 'ereader: A Pop In Time',
  levels: [0], // always set ereader levels to 0 - we consider ereader as single level game
  levelsMastered: [],
*/
const questState = {
  version: 1,
  language: 'en',
  captions: false,
  areCaptionsBlocked: false,
  adaptivityVersion: 3,
  season: SEASON.GRADE_K_1,
  gamesData: {},
  updated: '',
  stepFailures: {
    currentLevel: -1,
  },
  observationApiFailures: {},
  writeResultFailures: {},
  showPracticeTab: false, // controls Practice Tab visibility
  practiceEnabledLocally: undefined, // controls Practice Tab visibility within the session
  placement: undefined, // last placement user was working in
  // did user see end of quests animation
  didEndOfQuestsPlay: false,
  // bites we earn in quest steps
  bitesEarnedInQuest: 0,
  // last opened/active quest location
  currentActiveLocation: mapLocations.SCHOOL,
  // current quest in progress
  currentActiveQuestId: 1,
  // indicates which quest got games from content service not to call adaptivity for this data again
  contentServiceQuestId: 0,
  // current quest session id
  questSessionId: '',
  // last quest user played before End Of Quests popup appeared
  lastQuestFinishedBeforeEndOfQuests: undefined,
  showChallengeQuestPopup: {
    [PRODUCT_READING]: false,
    [PRODUCT_LECTURA]: false,
  },
  userHadAllQuestsCompletePopupShown: {
    [PRODUCT_READING]: false,
    [PRODUCT_LECTURA]: false,
  },
  areAllQuestsAndChallengesComplete: {
    [PRODUCT_READING]: false,
    [PRODUCT_LECTURA]: false,
  },
  // Order of quests progression - local data only, no need to saveto server
  questsOrder: {
    quest1: {
      location: mapLocations.SCHOOL,
      nextQuestId: 2,
    },
    quest2: {
      location: mapLocations.HOME,
      nextQuestId: 3,
    },
    quest3: {
      location: mapLocations.CAFE,
      nextQuestId: 4,
    },
    quest4: {
      location: mapLocations.PARK,
      nextQuestId: 5,
    },
    quest5: {
      location: mapLocations.MARKET,
      nextQuestId: 6,
    },
    quest6: {
      location: mapLocations.CAFE,
      nextQuestId: 7,
    },
    quest7: {
      location: mapLocations.PARK,
      nextQuestId: 8,
    },
    quest8: {
      location: mapLocations.SCHOOL,
      nextQuestId: 9,
    },
    quest9: {
      location: mapLocations.CAFE,
      nextQuestId: 10,
    },
    quest10: {
      location: mapLocations.PARK,
      nextQuestId: 11,
    },
    quest11: {
      location: mapLocations.HOME,
      nextQuestId: 12,
    },
    quest12: {
      location: mapLocations.MARKET,
      nextQuestId: 13,
    },
    quest13: {
      location: mapLocations.HOME,
      nextQuestId: 14,
    },
    quest14: {
      location: mapLocations.CAFE,
      nextQuestId: 15,
    },
    quest15: {
      location: mapLocations.SCHOOL,
      nextQuestId: 16,
    },
    quest16: {
      location: mapLocations.PARK,
      nextQuestId: 17,
    },
    quest17: {
      location: mapLocations.MARKET,
      nextQuestId: 18,
    },
    quest18: {
      location: mapLocations.SCHOOL,
      nextQuestId: 19,
    },
    quest19: {
      location: mapLocations.HOME,
      nextQuestId: 20,
    },
    quest20: {
      location: mapLocations.PARK,
      nextQuestId: 21,
    },
    quest21: {
      location: mapLocations.HOME,
      nextQuestId: 22,
    },
    quest22: {
      location: mapLocations.SCHOOL,
      nextQuestId: 23,
    },
    quest23: {
      location: mapLocations.CAFE,
      nextQuestId: 24,
    },
    quest24: {
      location: mapLocations.MARKET,
      nextQuestId: 0,
    },
    quest201: {
      location: mapLocations.SCHOOL,
      nextQuestId: 202,
    },
    quest202: {
      location: mapLocations.PARK,
      nextQuestId: 203,
    },
    quest203: {
      location: mapLocations.CAFE,
      nextQuestId: 204,
    },
    quest204: {
      location: mapLocations.MARKET,
      nextQuestId: 205,
    },
    quest205: {
      location: mapLocations.HOUSE,
      nextQuestId: 206,
    },
    quest206: {
      location: mapLocations.PARK,
      nextQuestId: 207,
    },
    quest207: {
      location: mapLocations.SCHOOL,
      nextQuestId: 208,
    },
    quest208: {
      location: mapLocations.CAFE,
      nextQuestId: 209,
    },
    quest209: {
      location: mapLocations.SCHOOL,
      nextQuestId: 210,
    },
    quest210: {
      location: mapLocations.HOUSE,
      nextQuestId: 211,
    },
    quest211: {
      location: mapLocations.HOME,
      nextQuestId: 212,
    },
    quest212: {
      location: mapLocations.PARK,
      nextQuestId: 213,
    },
    quest213: {
      location: mapLocations.MARKET,
      nextQuestId: 214,
    },
    quest214: {
      location: mapLocations.HOUSE,
      nextQuestId: 215,
    },
    quest215: {
      location: mapLocations.HOUSE,
      nextQuestId: 216,
    },
    quest216: {
      location: mapLocations.MARKET,
      nextQuestId: 217,
    },
    quest217: {
      location: mapLocations.HOUSE,
      nextQuestId: 218,
    },
    quest218: {
      location: mapLocations.SCHOOL,
      nextQuestId: 219,
    },
    quest219: {
      location: mapLocations.HOUSE,
      nextQuestId: 220,
    },
    quest220: {
      location: mapLocations.PARK,
      nextQuestId: 221,
    },
    quest221: {
      location: mapLocations.HOME,
      nextQuestId: 222,
    },
    quest222: {
      location: mapLocations.PARK,
      nextQuestId: 223,
    },
    quest223: {
      location: mapLocations.HOUSE,
      nextQuestId: 224,
    },
    quest224: {
      location: mapLocations.HOUSE,
      nextQuestId: 0,
    },
  },
  questsNames: localizedStrings.questsNames,
  // matches location and quest(defaultQuestForLocation is dynamic)
  mapAreas: {
    version: 1,
    updated: '',
    [mapLocations.HOME]: {
      locationProgress: 0,
      lastStepToAnimate: '',
      locationOpened: false,
      defaultQuestForLocation: 2,
    },
    [mapLocations.CAFE]: {
      locationProgress: 0,
      lastStepToAnimate: '',
      locationOpened: false,
      defaultQuestForLocation: 3,
    },
    [mapLocations.SCHOOL]: {
      locationProgress: 0,
      lastStepToAnimate: '',
      locationOpened: true,
      defaultQuestForLocation: 1,
    },
    [mapLocations.PARK]: {
      locationProgress: 0,
      lastStepToAnimate: '',
      locationOpened: false,
      defaultQuestForLocation: 4,
    },
    [mapLocations.MARKET]: {
      locationProgress: 0,
      lastStepToAnimate: '',
      locationOpened: false,
      defaultQuestForLocation: 5,
    },
    [mapLocations.HOUSE]: {
      locationProgress: 0,
      lastStepToAnimate: '',
      locationOpened: false,
      defaultQuestForLocation: 205,
    },
  },
  // quests progress data
  quests: {
    ...MapQuests.quests,
    /* Quest 100 is used for End Of Quests Experience only */
    quest100: {
      steps: [],
    },
  },
  sideQuest: {
    showChallengeIconOnMap: false,
    showSideQuestAvailability: false,
    showSideQuestGamesPopup: false,
    games: [], // 3 games for side quest selection should go here from Adaptivity
    selectedGame: '',
  },
  ereaderKeys: [],
  //
  questCameraState: {
    index: null,
    arrows: {
      left: true,
      right: true,
    },
  },
  isPostQ1InteractionEnabled: false,
  isNotesTabVisible: false,
  unlockedGlyphPowers: [],
  newQuestReleased: undefined, // change to undefined when no new quests released
  showNewQuestsAvailablePopup: false,
  isQuestInDemoMode: false,
  isRePlacementModalShown: false,
  readingQuestStepsCache: [],
  lecturaQuestStepsCache: [],
};

export const questStateForDemo = {
  [SEASON.GRADE_K_1]: {
    version: 1,
    language: 'en',
    captions: false,
    areCaptionsBlocked: false,
    adaptivityVersion: 0,
    season: SEASON.GRADE_K_1,
    gamesData: {},
    updated: '',
    stepFailures: {
      currentLevel: -1,
    },
    observationApiFailures: {},
    writeResultFailures: {},
    showPracticeTab: true, // controls Practice Tab visibility
    practiceEnabledLocally: true, // controls Practice Tab visibility within the session
    placement: undefined,
    // did user see end of quests animation
    didEndOfQuestsPlay: false,
    // bites we earn in quest steps
    bitesEarnedInQuest: 0,
    // last opened/active quest location
    currentActiveLocation: mapLocations.SCHOOL,
    // current quest in progress
    currentActiveQuestId: 1,
    // indicates which quest got games from content service not to call adaptivity for this data again
    contentServiceQuestId: 1,
    questSessionId: '',
    // last quest user played before End Of Quests popup appeared
    lastQuestFinishedBeforeEndOfQuests: undefined,
    showChallengeQuestPopup: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    userHadAllQuestsCompletePopupShown: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    areAllQuestsAndChallengesComplete: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    // Order of quests progression - local data only, no need to saveto server
    questsOrder: {
      quest1: {
        location: mapLocations.SCHOOL,
        nextQuestId: 0,
      },
    },
    questsNames: localizedStrings.questsNames,
    // matches location and quest(defaultQuestForLocation is dynamic)
    mapAreas: {
      version: 1,
      updated: '',
      [mapLocations.HOME]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 2,
      },
      [mapLocations.CAFE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 3,
      },
      [mapLocations.SCHOOL]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: true,
        defaultQuestForLocation: 1,
      },
      [mapLocations.PARK]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 4,
      },
      [mapLocations.MARKET]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 5,
      },
      [mapLocations.HOUSE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 205,
      },
    },
    // quests progress data
    quests: {
      version: 1,
      quest1: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.WORD_CITY,
            levels: [14],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.PICKY_GOBLINS,
            levels: [7],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.EREADER,
            game: 'ereader.pop_in_time',
            friendlyName: 'eReader: A Pop in Time',
            levels: [0],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_READING,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      quest201: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.UNMASK_THAT,
            levels: [4],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.CURIOSO_CROSSING,
            levels: [100],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.EREADER,
            game: 'ereader.lifting_up_the_sky',
            friendlyName: 'eReader: Lifting Up the Sky',
            levels: [0],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.VOCAB,
            game: gameIds.VOCAB,
            levels: [0],
            levelsMastered: [],
            skillId: -4,
            product: PRODUCT_READING,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      /* Quest 100 is used for End Of Quests Experience only */
      quest100: {
        steps: [],
      },
    },
    sideQuest: {
      showChallengeIconOnMap: false,
      showSideQuestAvailability: false,
      showSideQuestGamesPopup: false,
      games: [], // 3 games for side quest selection should go here from Adaptivity
      selectedGame: '',
    },
    ereaderKeys: [],
    //
    questCameraState: {
      index: null,
      arrows: {
        left: true,
        right: true,
      },
    },
    isPostQ1InteractionEnabled: false,
    isNotesTabVisible: false,
    unlockedGlyphPowers: [],
    newQuestReleased: undefined, // change to undefined when no new quests released
    showNewQuestsAvailablePopup: false,
    isQuestInDemoMode: true,
    isRePlacementModalShown: false,
    readingQuestStepsCache: [],
    lecturaQuestStepsCache: [],
    gameLevelConceptMap: {}, // for Embedded Measurement games
  },
  [SEASON.GRADE_2_3]: {
    version: 1,
    language: 'en',
    captions: false,
    adaptivityVersion: 0,
    season: SEASON.GRADE_2_3,
    gamesData: {},
    updated: '',
    stepFailures: {
      currentLevel: -1,
    },
    observationApiFailures: {},
    writeResultFailures: {},
    showPracticeTab: true, // controls Practice Tab visibility
    practiceEnabledLocally: true, // controls Practice Tab visibility within the session
    placement: undefined,
    // did user see end of quests animation
    didEndOfQuestsPlay: false,
    // bites we earn in quest steps
    bitesEarnedInQuest: 0,
    // last opened/active quest location
    currentActiveLocation: mapLocations.SCHOOL,
    // current quest in progress
    currentActiveQuestId: 201,
    // indicates which quest got games from content service not to call adaptivity for this data again
    contentServiceQuestId: 201,
    questSessionId: '',
    // last quest user played before End Of Quests popup appeared
    lastQuestFinishedBeforeEndOfQuests: undefined,
    showChallengeQuestPopup: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    userHadAllQuestsCompletePopupShown: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    areAllQuestsAndChallengesComplete: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    // Order of quests progression - local data only, no need to saveto server
    questsOrder: {
      quest201: {
        location: mapLocations.SCHOOL,
        nextQuestId: 0,
      },
    },
    questsNames: localizedStrings.questsNames,
    // matches location and quest(defaultQuestForLocation is dynamic)
    mapAreas: {
      version: 1,
      updated: '',
      [mapLocations.HOME]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 2,
      },
      [mapLocations.CAFE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 3,
      },
      [mapLocations.SCHOOL]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: true,
        defaultQuestForLocation: 201,
      },
      [mapLocations.PARK]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 202,
      },
      [mapLocations.MARKET]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 5,
      },
      [mapLocations.HOUSE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 205,
      },
    },
    // quests progress data
    quests: {
      version: 1,
      quest1: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.WORD_CITY,
            levels: [14],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.PICKY_GOBLINS,
            levels: [7],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.EREADER,
            game: 'ereader.pop_in_time',
            friendlyName: 'eReader: A Pop in Time',
            levels: [0],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_READING,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 0,
        locationSettings: {},
      },
      quest201: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.UNMASK_THAT,
            levels: [4],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.CURIOSO_CROSSING,
            levels: [100],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.EREADER,
            game: 'ereader.lifting_up_the_sky',
            friendlyName: 'eReader: Lifting Up the Sky',
            levels: [0],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.VOCAB,
            game: gameIds.VOCAB,
            levels: [0],
            levelsMastered: [],
            skillId: -4,
            product: PRODUCT_READING,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      /* Quest 100 is used for End Of Quests Experience only */
      quest100: {
        steps: [],
      },
    },
    sideQuest: {
      showChallengeIconOnMap: false,
      showSideQuestAvailability: false,
      showSideQuestGamesPopup: false,
      games: [], // 3 games for side quest selection should go here from Adaptivity
      selectedGame: '',
    },
    ereaderKeys: [],
    //
    questCameraState: {
      index: null,
      arrows: {
        left: true,
        right: true,
      },
    },
    isPostQ1InteractionEnabled: false,
    isNotesTabVisible: false,
    unlockedGlyphPowers: [],
    newQuestReleased: undefined, // change to undefined when no new quests released
    showNewQuestsAvailablePopup: false,
    isQuestInDemoMode: true,
    isRePlacementModalShown: false,
    readingQuestStepsCache: [],
    lecturaQuestStepsCache: [],
    gameLevelConceptMap: {}, // for Embedded Measurement games
  },
  [SEASON.GRADE_4_5]: {
    version: 1,
    language: 'en',
    captions: false,
    adaptivityVersion: 0,
    season: SEASON.GRADE_2_3,
    gamesData: {},
    updated: '',
    stepFailures: {
      currentLevel: -1,
    },
    observationApiFailures: {},
    writeResultFailures: {},
    showPracticeTab: true, // controls Practice Tab visibility
    practiceEnabledLocally: true, // controls Practice Tab visibility within the session
    placement: undefined,
    // did user see end of quests animation
    didEndOfQuestsPlay: false,
    // bites we earn in quest steps
    bitesEarnedInQuest: 0,
    // last opened/active quest location
    currentActiveLocation: mapLocations.SCHOOL,
    // current quest in progress
    currentActiveQuestId: 201,
    // indicates which quest got games from content service not to call adaptivity for this data again
    contentServiceQuestId: 201,
    // last quest user played before End Of Quests popup appeared
    lastQuestFinishedBeforeEndOfQuests: undefined,
    showChallengeQuestPopup: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    userHadAllQuestsCompletePopupShown: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    areAllQuestsAndChallengesComplete: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    questSessionId: '',
    // Order of quests progression - local data only, no need to saveto server
    questsOrder: {
      quest201: {
        location: mapLocations.SCHOOL,
        nextQuestId: 0,
      },
    },
    questsNames: localizedStrings.questsNames,
    // matches location and quest(defaultQuestForLocation is dynamic)
    mapAreas: {
      version: 1,
      updated: '',
      [mapLocations.HOME]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 2,
      },
      [mapLocations.CAFE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 3,
      },
      [mapLocations.SCHOOL]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: true,
        defaultQuestForLocation: 201,
      },
      [mapLocations.PARK]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 202,
      },
      [mapLocations.MARKET]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 5,
      },
      [mapLocations.HOUSE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 205,
      },
    },
    // quests progress data
    quests: {
      version: 1,
      quest1: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.WORD_CITY,
            levels: [14],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [0],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.EREADER,
            game: 'ereader.pop_in_time',
            friendlyName: 'eReader: A Pop in Time',
            levels: [0],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_READING,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 0,
        locationSettings: {},
      },
      quest201: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.UNMASK_THAT,
            levels: [4],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.CURIOSO_CROSSING,
            levels: [100],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.EREADER,
            game: 'ereader.lifting_up_the_sky',
            friendlyName: 'eReader: Lifting Up the Sky',
            levels: [0],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_READING,
          },
          {
            type: STEP_TYPE.VOCAB,
            game: gameIds.VOCAB,
            levels: [0],
            levelsMastered: [],
            skillId: -4,
            product: PRODUCT_READING,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 0,
        locationSettings: {},
      },
      /* Quest 100 is used for End Of Quests Experience only */
      quest100: {
        steps: [],
      },
    },
    sideQuest: {
      showChallengeIconOnMap: false,
      showSideQuestAvailability: false,
      showSideQuestGamesPopup: false,
      games: [], // 3 games for side quest selection should go here from Adaptivity
      selectedGame: '',
    },
    ereaderKeys: [],
    //
    questCameraState: {
      index: null,
      arrows: {
        left: true,
        right: true,
      },
    },
    isPostQ1InteractionEnabled: false,
    isNotesTabVisible: false,
    unlockedGlyphPowers: [],
    newQuestReleased: undefined, // change to undefined when no new quests released
    showNewQuestsAvailablePopup: false,
    isQuestInDemoMode: true,
    isRePlacementModalShown: false,
    readingQuestStepsCache: [],
    lecturaQuestStepsCache: [],
    gameLevelConceptMap: {}, // for Embedded Measurement games
  },
};
export const questStateForLecturaDemo = {
  [SEASON.GRADE_K_1]: {
    version: 1,
    language: 'en',
    captions: false,
    areCaptionsBlocked: false,
    adaptivityVersion: 0,
    season: SEASON.GRADE_K_1,
    gamesData: {},
    updated: '',
    stepFailures: {
      currentLevel: -1,
    },
    observationApiFailures: {},
    writeResultFailures: {},
    showPracticeTab: true, // controls Practice Tab visibility
    practiceEnabledLocally: true, // controls Practice Tab visibility within the session
    placement: undefined,
    // did user see end of quests animation
    didEndOfQuestsPlay: false,
    // bites we earn in quest steps
    bitesEarnedInQuest: 0,
    // last opened/active quest location
    currentActiveLocation: mapLocations.SCHOOL,
    // current quest in progress
    currentActiveQuestId: 1,
    // indicates which quest got games from content service not to call adaptivity for this data again
    contentServiceQuestId: 1,
    questSessionId: '',
    // last quest user played before End Of Quests popup appeared
    lastQuestFinishedBeforeEndOfQuests: undefined,
    showChallengeQuestPopup: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    userHadAllQuestsCompletePopupShown: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    areAllQuestsAndChallengesComplete: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    // Order of quests progression - local data only, no need to saveto server
    questsOrder: {
      quest1: {
        location: mapLocations.SCHOOL,
        nextQuestId: 0,
      },
    },
    questsNames: localizedStrings.questsNames,
    // matches location and quest(defaultQuestForLocation is dynamic)
    mapAreas: {
      version: 1,
      updated: '',
      [mapLocations.HOME]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 2,
      },
      [mapLocations.CAFE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 3,
      },
      [mapLocations.SCHOOL]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: true,
        defaultQuestForLocation: 1,
      },
      [mapLocations.PARK]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 4,
      },
      [mapLocations.MARKET]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 5,
      },
      [mapLocations.HOUSE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 205,
      },
    },
    // quests progress data
    quests: {
      version: 1,
      quest1: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.GEM_NYE_FRIENDS,
            levels: [23, 24],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [2, 3, 4],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [17],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_LECTURA,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      quest201: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.GEM_NYE_FRIENDS,
            levels: [23, 24],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [2, 3, 4],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [17],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [18],
            levelsMastered: [],
            skillId: -4,
            product: PRODUCT_LECTURA,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      /* Quest 100 is used for End Of Quests Experience only */
      quest100: {
        steps: [],
      },
    },
    sideQuest: {
      showChallengeIconOnMap: false,
      showSideQuestAvailability: false,
      showSideQuestGamesPopup: false,
      games: [], // 3 games for side quest selection should go here from Adaptivity
      selectedGame: '',
    },
    ereaderKeys: [],
    //
    questCameraState: {
      index: null,
      arrows: {
        left: true,
        right: true,
      },
    },
    isPostQ1InteractionEnabled: false,
    isNotesTabVisible: false,
    unlockedGlyphPowers: [],
    newQuestReleased: undefined, // change to undefined when no new quests released
    showNewQuestsAvailablePopup: false,
    isQuestInDemoMode: true,
    isRePlacementModalShown: false,
    readingQuestStepsCache: [],
    lecturaQuestStepsCache: [],
  },
  [SEASON.GRADE_2_3]: {
    version: 1,
    language: 'en',
    captions: false,
    adaptivityVersion: 0,
    season: SEASON.GRADE_2_3,
    gamesData: {},
    updated: '',
    stepFailures: {
      currentLevel: -1,
    },
    observationApiFailures: {},
    writeResultFailures: {},
    showPracticeTab: true, // controls Practice Tab visibility
    practiceEnabledLocally: true, // controls Practice Tab visibility within the session
    placement: undefined,
    // did user see end of quests animation
    didEndOfQuestsPlay: false,
    // bites we earn in quest steps
    bitesEarnedInQuest: 0,
    // last opened/active quest location
    currentActiveLocation: mapLocations.SCHOOL,
    // current quest in progress
    currentActiveQuestId: 201,
    // indicates which quest got games from content service not to call adaptivity for this data again
    contentServiceQuestId: 201,
    questSessionId: '',
    // last quest user played before End Of Quests popup appeared
    lastQuestFinishedBeforeEndOfQuests: undefined,
    showChallengeQuestPopup: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    userHadAllQuestsCompletePopupShown: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    areAllQuestsAndChallengesComplete: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    // Order of quests progression - local data only, no need to saveto server
    questsOrder: {
      quest201: {
        location: mapLocations.SCHOOL,
        nextQuestId: 0,
      },
    },
    questsNames: localizedStrings.questsNames,
    // matches location and quest(defaultQuestForLocation is dynamic)
    mapAreas: {
      version: 1,
      updated: '',
      [mapLocations.HOME]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 2,
      },
      [mapLocations.CAFE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 3,
      },
      [mapLocations.SCHOOL]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: true,
        defaultQuestForLocation: 201,
      },
      [mapLocations.PARK]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 202,
      },
      [mapLocations.MARKET]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 5,
      },
      [mapLocations.HOUSE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 205,
      },
    },
    // quests progress data
    quests: {
      version: 1,
      quest1: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.GEM_NYE_FRIENDS,
            levels: [23, 24],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [2, 3, 4],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [17],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_LECTURA,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      quest201: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.GEM_NYE_FRIENDS,
            levels: [23, 24],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [2, 3, 4],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [17],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [18],
            levelsMastered: [],
            skillId: -4,
            product: PRODUCT_LECTURA,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      /* Quest 100 is used for End Of Quests Experience only */
      quest100: {
        steps: [],
      },
    },
    sideQuest: {
      showChallengeIconOnMap: false,
      showSideQuestAvailability: false,
      showSideQuestGamesPopup: false,
      games: [], // 3 games for side quest selection should go here from Adaptivity
      selectedGame: '',
    },
    ereaderKeys: [],
    //
    questCameraState: {
      index: null,
      arrows: {
        left: true,
        right: true,
      },
    },
    isPostQ1InteractionEnabled: false,
    isNotesTabVisible: false,
    unlockedGlyphPowers: [],
    newQuestReleased: undefined, // change to undefined when no new quests released
    showNewQuestsAvailablePopup: false,
    isQuestInDemoMode: true,
    isRePlacementModalShown: false,
    readingQuestStepsCache: [],
    lecturaQuestStepsCache: [],
  },
  [SEASON.GRADE_4_5]: {
    version: 1,
    language: 'en',
    captions: false,
    adaptivityVersion: 0,
    season: SEASON.GRADE_2_3,
    gamesData: {},
    updated: '',
    stepFailures: {
      currentLevel: -1,
    },
    observationApiFailures: {},
    writeResultFailures: {},
    showPracticeTab: true, // controls Practice Tab visibility
    practiceEnabledLocally: true, // controls Practice Tab visibility within the session
    placement: undefined,
    // did user see end of quests animation
    didEndOfQuestsPlay: false,
    // bites we earn in quest steps
    bitesEarnedInQuest: 0,
    // last opened/active quest location
    currentActiveLocation: mapLocations.SCHOOL,
    // current quest in progress
    currentActiveQuestId: 201,
    // indicates which quest got games from content service not to call adaptivity for this data again
    contentServiceQuestId: 201,
    // last quest user played before End Of Quests popup appeared
    lastQuestFinishedBeforeEndOfQuests: undefined,
    showChallengeQuestPopup: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    userHadAllQuestsCompletePopupShown: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    areAllQuestsAndChallengesComplete: {
      [PRODUCT_READING]: false,
      [PRODUCT_LECTURA]: false,
    },
    questSessionId: '',
    // Order of quests progression - local data only, no need to saveto server
    questsOrder: {
      quest201: {
        location: mapLocations.SCHOOL,
        nextQuestId: 0,
      },
    },
    questsNames: localizedStrings.questsNames,
    // matches location and quest(defaultQuestForLocation is dynamic)
    mapAreas: {
      version: 1,
      updated: '',
      [mapLocations.HOME]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 2,
      },
      [mapLocations.CAFE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 3,
      },
      [mapLocations.SCHOOL]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: true,
        defaultQuestForLocation: 201,
      },
      [mapLocations.PARK]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 202,
      },
      [mapLocations.MARKET]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 5,
      },
      [mapLocations.HOUSE]: {
        locationProgress: 0,
        lastStepToAnimate: '',
        locationOpened: false,
        defaultQuestForLocation: 205,
      },
    },
    // quests progress data
    quests: {
      version: 1,
      quest1: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.GEM_NYE_FRIENDS,
            levels: [23, 24],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [2, 3, 4],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [17],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_LECTURA,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      quest201: {
        version: 1,
        questSessionId: '',
        steps: [
          {
            type: STEP_TYPE.GAME,
            game: gameIds.GEM_NYE_FRIENDS,
            levels: [23, 24],
            levelsMastered: [],
            skillId: -1,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.HANGRY_GOBLINS,
            levels: [2, 3, 4],
            levelsMastered: [],
            skillId: -2,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [17],
            levelsMastered: [],
            skillId: -3,
            product: PRODUCT_LECTURA,
          },
          {
            type: STEP_TYPE.GAME,
            game: gameIds.SILABALON,
            levels: [18],
            levelsMastered: [],
            skillId: -4,
            product: PRODUCT_LECTURA,
          },
        ],
        updated: '',
        startDate: '',
        questIntroPlayed: 1,
        locationSettings: {},
      },
      /* Quest 100 is used for End Of Quests Experience only */
      quest100: {
        steps: [],
      },
    },
    sideQuest: {
      showChallengeIconOnMap: false,
      showSideQuestAvailability: false,
      showSideQuestGamesPopup: false,
      games: [], // 3 games for side quest selection should go here from Adaptivity
      selectedGame: '',
    },
    ereaderKeys: [],
    //
    questCameraState: {
      index: null,
      arrows: {
        left: true,
        right: true,
      },
    },
    isPostQ1InteractionEnabled: false,
    isNotesTabVisible: false,
    unlockedGlyphPowers: [],
    newQuestReleased: undefined, // change to undefined when no new quests released
    showNewQuestsAvailablePopup: false,
    isQuestInDemoMode: true,
    isRePlacementModalShown: false,
    readingQuestStepsCache: [],
    lecturaQuestStepsCache: [],
  },
};

export default questState;
